// extracted by mini-css-extract-plugin
module.exports = {"navbar":"navbar_navbar__q1H5d"};